// Centralised asset URLs for easy maintenance
// Social
export const OG_IMAGE =
  'https://cdn.magicpatterns.com/uploads/wMntJsJ5cNrkriF1HsCPRo/Portfolio_Social_Preview_Image.jpg'

// Logo
export const LOGO_SVG =
  'https://uploadthingy.s3.us-west-1.amazonaws.com/kUJkvt7eZfsF9tkKGwhnju/mintextract%C2%A9.svg'

// Case study slides — Complexity
export const SLIDE_COMPLEXITY =
  'https://cdn.magicpatterns.com/uploads/6ad4CNyysTrpZ6q3CrKNy5/Slide_1.svg'

// Case study slides — Research
export const SLIDE_RESEARCH =
  'https://cdn.magicpatterns.com/uploads/e8HGASn8AXvEBkhrV9NWbQ/Slide_2.svg'

// Case study slides — Systems
export const SLIDE_SYSTEMS =
  'https://cdn.magicpatterns.com/uploads/u6sZKtUbYGfjrCMCMEnRQA/Slide_3.svg'

// Homepage background watermark
export const HERO_WATERMARK =
  'https://cdn.magicpatterns.com/uploads/be3CGkXfHayGnTbgXgt4TZ/Hero.logo-1000px.png'

// Base URL
export const BASE_URL = 'https://mintextract.design'
